// Sign in / Create account tab toggle on the My Account login-register page
// (woocommerce/myaccount/form-login.php override).

function init() {
    const tabsWrap = document.querySelector('[data-auth-tabs]');
    const switchButtons = document.querySelectorAll('.auth-layout__switch [data-auth-tab]');
    const allTabButtons = document.querySelectorAll('[data-auth-tab]');
    const panels = document.querySelectorAll('[data-auth-panel]');
    if (!allTabButtons.length || !panels.length) return;

    function activate(tab) {
        document.querySelectorAll('.auth-layout__tab').forEach((btn) => {
            btn.classList.toggle('auth-layout__tab--active', btn.getAttribute('data-auth-tab') === tab);
        });
        panels.forEach((panel) => {
            panel.classList.toggle('auth-layout__panel--active', panel.getAttribute('data-auth-panel') === tab);
        });
    }

    allTabButtons.forEach((btn) => {
        btn.addEventListener('click', () => activate(btn.getAttribute('data-auth-tab')));
    });
}

export default { init };
